import Seo from '../components/Seo';
import GildaOrderBuilder from '../components/GildaOrderBuilder';
import SmartImg from '../components/SmartImg';
import { GILDAS } from '../data/gildas';
import { breadcrumb } from '../lib/seo-schemas';

export default function Pedido() {
  return (
    <>
      <Seo
        title="Pide tus gildas por WhatsApp"
        description="Arma tu bandeja de gildas artesanas del Bar Cabrero (Torrelavega): elige cantidades, día y hora dentro de nuestro horario de apertura, y te llega el pedido directo por WhatsApp. Mínimo 12 unidades, dos días de antelación."
        path="/pedido"
        schemas={[breadcrumb([{ name: 'Pedir bandeja', path: '/pedido' }])]}
      />

      {/* HERO */}
      <section className="sec sec-surf" data-testid="pedido-page">
        <div className="ped-hero">
          <p className="eyebrow rv">Pídelo por WhatsApp</p>
          <h1 className="D D-xl rv" style={{ marginBottom: '1.25rem' }}>
            Arma tu <em>bandeja.</em>
          </h1>
          <p className="lead rv" style={{ marginBottom: '1.25rem' }}>
            Elige cuántas gildas de cada variedad, el día y la hora dentro de nuestro horario de apertura. Te mandamos el pedido directo por WhatsApp y nosotros confirmamos.
          </p>
          <p className="copy rv" style={{ maxWidth: '46rem' }}>
            Mínimo 12 unidades. Avísanos con al menos dos días — cuanto más, mejor. Hechas a mano cada mañana, como siempre.
          </p>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="sec sec-sm" data-testid="pedido-howto">
        <div className="ped-steps rv">
          {[
            ['01', 'Elige cantidades', 'Suma y resta de cada variedad. Mínimo 12 gildas.'],
            ['02', 'Día y hora', 'Solo dejamos elegir dentro del horario de apertura. Cerramos los martes.'],
            ['03', 'Confirmamos por WhatsApp', 'Llega un mensaje pre-rellenado. Tú lo envías, nosotros respondemos.'],
          ].map(([n, t, d]) => (
            <div className="ped-step" key={n}>
              <span className="ped-step-n">{n}</span>
              <h3 className="ped-step-t">{t}</h3>
              <p className="ped-step-d">{d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* THE BUILDER */}
      <GildaOrderBuilder />

      {/* GILDAS GALLERY — visual reminder + 1-click add */}
      <section className="sec ped-gallery-section" data-testid="pedido-gallery">
        <p className="eyebrow rv">Las 12 que hacemos · pulsa para añadir</p>
        <h2 className="D D-md rv" style={{ marginBottom: '2rem' }}>
          Una a una, <em>a mano.</em>
        </h2>
        <div className="ped-gallery rv">
          {GILDAS.map((g) => (
            <button
              type="button"
              className="ped-gtile"
              key={g.num}
              onClick={(e) => {
                window.dispatchEvent(new CustomEvent('gilda:add', { detail: { num: g.num } }));
                // floaty +1 animation
                const el = e.currentTarget;
                const span = document.createElement('span');
                span.className = 'ped-plus';
                span.textContent = '+1';
                el.appendChild(span);
                setTimeout(() => span.remove(), 900);
                // On mobile, gently scroll to the order summary so users see progress
                if (typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches) {
                  const bar = document.querySelector('[data-testid="order-summary-bar"]');
                  if (bar) bar.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
              }}
              data-testid={`gallery-tile-${g.num}`}
              aria-label={`Añadir una ${g.name} al pedido`}
            >
              <SmartImg src={g.img} alt={`Gilda ${g.name} — ${g.desc}`} />
              <span className="ped-gtile-cap">
                <span className="ped-gtile-n">{g.num}</span>
                <span className="ped-gtile-name">{g.name}</span>
              </span>
            </button>
          ))}
        </div>
        <p className="ped-gallery-foot rv">
          Cada toque suma una unidad arriba. Cambia tu selección cuando quieras.
        </p>
      </section>
    </>
  );
}
